import { render } from "./LandscapingDataSourceDetailsCard.vue?vue&type=template&id=2ca02387&scoped=true"
import script from "./LandscapingDataSourceDetailsCard.vue?vue&type=script&lang=js"
export * from "./LandscapingDataSourceDetailsCard.vue?vue&type=script&lang=js"

import "./LandscapingDataSourceDetailsCard.vue?vue&type=style&index=0&id=2ca02387&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca02387"]])

export default __exports__